/**
 * @typedef {import('./strategyTypes').PersistentStorage} PersistentStorage
 * @typedef {import('./strategyTypes').PersistentStorageStrategy} PersistentStorageStrategy
 */

/** @type {PersistentStorage} */
const localStorageProxy = {
  getItem(keyName) {
    return window.localStorage.getItem(keyName);
  },
  getAllItems() {
    return window.localStorage;
  },
  setItem(keyName, keyValue) {
    window.localStorage.setItem(keyName, keyValue);
  },
  removeItem(keyName) {
    window.localStorage.removeItem(keyName);
  },
  clear() {
    window.localStorage.clear();
  },
  get length() {
    return window.localStorage.length;
  }
};

/** @type {PersistentStorageStrategy} */
export const localStorageStrategy = {
  name: 'localStorageStrategy',
  isSupported: () => {
    if (
      typeof window === 'undefined' ||
      typeof window.localStorage === 'undefined'
    )
      return false;

    try {
      const testKey = '__some_random_key_you_are_not_going_to_use__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  },
  storageInstance: () => localStorageProxy
};
